import React, {Component} from 'react';
import moment from 'moment';
import {DATE_FORMAT, TIME_FORMAT, DATE_TIME_FORMAT} from '../helpers/DateHelper';
import 'react-datetime/css/react-datetime.css';
import '../../../scss/date-time-picker.scss';

let ReactDateTime = require('react-datetime');

export default class DateTimePicker extends React.Component{
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.onChange(this.props.value);
    }

    onChange(moment) {
        if (moment.constructor.name === 'Moment') {
            this.props.formInput.onChange(moment.format(DATE_TIME_FORMAT));
        }
    }

    componentWillReceiveProps(nextProps) {
        if(!nextProps.minDate) {
            return;
        }

        if(!nextProps.formInput.value || (nextProps.minDate.unix() > moment(nextProps.formInput.value, DATE_TIME_FORMAT).unix())) {
            this.onChange(nextProps.minDate);
        }
    }

    isValidDate(currentDate) {
        this.minDate = this.props.minDate || moment().startOf('day');
        this.minDate.startOf('day');
        if(currentDate.unix() < this.minDate.unix()) {
            return false;
        }

        return true;
    }

    render() {
        let {
            value = moment(),
            dateFormat = DATE_FORMAT,
            timeFormat = TIME_FORMAT,
            input = true,
            open,
            onChange = this.onChange.bind(this),
            isValidDate = this.isValidDate.bind(this),
            onFocus,
            onBlur,
            className,
            inputProps,
        } = this.props;

        return <ReactDateTime
            value={value}
            dateFormat={dateFormat}
            timeFormat={timeFormat}
            input={input}
            open={open}
            onChange={onChange}
            isValidDate={isValidDate}
            onFocus={onFocus}
            onBlur={onBlur}
            className={'col-sm-12'}
            inputProps={{className: 'col-sm-12 form-control default-date-picker--input'}}
        />;
    }
};


// WEBPACK FOOTER //
// ./web/src/components/common/DateTimePicker.jsx